import script from "./OsbFootLastProposals.vue?vue&type=script&setup=true&lang=js"
export * from "./OsbFootLastProposals.vue?vue&type=script&setup=true&lang=js"

import "./OsbFootLastProposals.vue?vue&type=style&index=0&id=9c629f8a&lang=css"
import "./OsbFootLastProposals.vue?vue&type=style&index=1&id=9c629f8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c629f8a"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';import TouchPan from 'quasar/src/directives/touch-pan/TouchPan.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QPageContainer,QPage,QTable,QTr,QTh,QTd,QBtn,QTooltip,QPageSticky,QBtnGroup,QSpinnerHourglass,QSlider});qInstall(script, 'directives', {TouchPan});
